// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"308":"continueonpc","352":"onboarding","530":"simulation","817":"finished","962":"home"}[chunkId] || chunkId) + "." + {"187":"67721095","308":"9338c972","352":"a269b55e","530":"c4759a0f","817":"b5697771","962":"e5badbd9"}[chunkId] + ".js";
};